import axios from 'axios';
import { getEducationPeriodForSubject } from 'chameleon-src/components/auth/utils';
import getFilteredSectionsLists from 'chameleon-src/components/assign/AssignManageForm/utils/getFilteredSectionsLists';
import {
  calculateClassesStats,
  updateSectionsWithFormStructure,
} from 'chameleon-src/components/assign/AssignManageForm/utils';
import { getMinTimezone } from 'chameleon-src/utility/utils';

const getAssignments = async (props, callback) => {
  const {
    state,
    assessmentGroupInfo,
    isFinalExam,
    assignment,
    subject,
    userData,
    itemId,
    individualStudentAssignmentFlag,
    subjectClasses,
    autoSelectedGroups,
    selectedGroups,
    classesStats,
    assessmentWithQuestionsData: { questions },
    hasPreassignedBehavior,
  } = props;
  let newState;
  let newDisabledStudents = [];
  let newStats = {};

  if (!assignment) {
    const educationPeriod = getEducationPeriodForSubject({
      subjectId: subject,
      userData,
    });
    let itemIds = isFinalExam
      ? assessmentGroupInfo.members.map((m) => m.assessmentId)
      : [itemId];
    const getAssignmentsResponse = await axios.get(
      `${FYM_BACKEND_URL}/assessments/api/assignments/`,
      {
        params: {
          status: 'locked,opened,closed',
          item_ids: itemIds.join(','),
          subject,
          educationPeriod,
        },
      },
    );

    if (getAssignmentsResponse) {
      const {
        assignments,
        options: { groups },
        default_timezone: assignmentsDefaultTimezone,
      } = getAssignmentsResponse.data;

      let {
        sectionsNotAssigned,
        preassignedSections,
        inProgressSections,
        reassignSections,
        auxDisabledStudents,
      } = getFilteredSectionsLists({
        assignments,
        groups,
        individualStudentAssignmentFlag,
        isFinalExam,
        subjectClasses,
        hasPreassignedBehavior,
      });
      autoSelectedGroups.current.push(
        ...sectionsNotAssigned.filter(
          (group) =>
            selectedGroups.current.assign &&
            selectedGroups.current.assign.includes(group.id),
        ),
      );
      autoSelectedGroups.current.push(
        ...reassignSections.filter(
          (group) =>
            selectedGroups.current.reAssign &&
            selectedGroups.current.reAssign.includes(group.id),
        ),
      );

      newStats = calculateClassesStats({
        stats: classesStats,
        classList: subjectClasses,
        disabledStudents: auxDisabledStudents,
      });

      const inProgressSectionIds = inProgressSections.map(
        (section) => section.id,
      );
      const groupTimezones = groups
        .filter((group) => !inProgressSectionIds.includes(group.id))
        .map((group) => group.timezone);

      sectionsNotAssigned =
        updateSectionsWithFormStructure(sectionsNotAssigned);
      reassignSections = updateSectionsWithFormStructure(reassignSections);
      preassignedSections =
        updateSectionsWithFormStructure(preassignedSections);
      inProgressSections = updateSectionsWithFormStructure(inProgressSections);

      newDisabledStudents = auxDisabledStudents;
      newState = {
        ...state,
        isLoading: false,
        gettingAssignmentGroups: false,
        assignmentGroupsLoaded: true,
        studentScoringPossible: !isFinalExam
          ? questions &&
            questions.some((q) => q.type === 'FreeResponseQuestion')
          : false,
        regularSections: sectionsNotAssigned.concat(reassignSections),
        updateSections: preassignedSections,
        progressSections: inProgressSections,
        defaultTimezone: assignmentsDefaultTimezone,
        sectionsMinTimezone:
          getMinTimezone(groupTimezones) || assignmentsDefaultTimezone,
      };
    } else {
      // TODO: Check for errors
      // log('error', err);
    }
  }

  callback && callback(newState, newDisabledStudents, newStats);
};

export default getAssignments;
